import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Grid,
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CloseIcon from "@mui/icons-material/Close";

const ImagenProduct = ({ onImagesChange }) => {
  const [images, setImages] = useState([]);
  const [openImage, setOpenImage] = useState(null);

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    const updatedImages = [...images, ...newImages];
    setImages(updatedImages);
    if (onImagesChange) {
      onImagesChange(updatedImages.map((img) => img.file));
    }
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    if (onImagesChange) {
      onImagesChange(updatedImages.map((img) => img.file));
    }
  };

  const handleOpenImage = (preview) => {
    setOpenImage(preview);
  };

  const handleCloseImage = () => {
    setOpenImage(null);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1565C0" }}>
        Imágenes del Producto
      </Typography>

      <Button
        variant="contained"
        component="label"
        startIcon={<AddPhotoAlternateIcon />}
        sx={{
          width: "100%",
          mb: 3,
          backgroundColor: "#1565C0",
          "&:hover": { backgroundColor: "#0d47a1" },
          textTransform: "none",
          boxShadow: 3,
        }}
      >
        Agregar Imágenes
        <input type="file" hidden accept="image/*" multiple onChange={handleImageUpload} />
      </Button>

      <Grid container spacing={2}>
        {images.map((imgObj, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Card
              sx={{
                width: "100%",
                paddingTop: "100%", // cuadrado
                position: "relative",
                borderRadius: 2,
                boxShadow: 4,
                overflow: "hidden",
                cursor: "pointer",
                "&:hover": { boxShadow: 6 },
              }}
              onClick={() => handleOpenImage(imgObj.preview)}
            >
              <CardMedia
                component="img"
                image={imgObj.preview}
                alt={`Imagen ${index + 1}`}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveImage(index);
                }}
                size="small"
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  padding: "4px",
                  zIndex: 1,
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={Boolean(openImage)} onClose={handleCloseImage} maxWidth="md" fullWidth>
        <DialogActions sx={{ p: 1 }}>
          <IconButton onClick={handleCloseImage} sx={{ ml: "auto" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogActions>
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box
            component="img"
            src={openImage}
            alt="Vista Previa"
            sx={{
              width: "100%",
              maxHeight: "600px",
              objectFit: "contain",
              borderRadius: 2,
              boxShadow: 3,
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ImagenProduct;
